<main class="numeros">
  <header class="topo">
    <div class="topo__titulo">
      <a class="migalha" routerLink="/admin/mia-gestor"><i class="fas fa-chevron-left" aria-hidden="true"></i> Mia Gestor</a>
      <h1>Números da Mia Gestor</h1>
      <p>A Mia Gestor responde mensagens de implantação e comerciais. Defina em qual número ela atende e quem pode conversar com ela.</p>
    </div>
    <button type="button" class="fantasma" (click)="carregue(); carregueV4()" [disabled]="carregando || salvando">
      <i class="fas fa-sync-alt" [class.girando]="carregando" aria-hidden="true"></i>
      {{ carregando ? 'Atualizando…' : 'Atualizar' }}
    </button>
  </header>

  <!-- Resumo dos dois canais: cada cartão leva à sua seção. -->
  <nav class="resumo" aria-label="Canais da Mia Gestor">
    <button type="button" class="resumo__cartao" (click)="rolePara('canal-v4')">
      <span class="resumo__icone" [class.ligado]="atualV4" aria-hidden="true"><i class="fas fa-mobile-alt"></i></span>
      <span class="resumo__corpo">
        <span class="resumo__rotulo">WhatsApp pessoal · Extensão V4</span>
        <strong class="num">{{ atualV4 ? formateTelefone(atualV4.telefone) : 'Nenhum número' }}</strong>
        <small *ngIf="atualV4">{{ atualV4.sdrContatos === '*' ? 'Todos os leads autorizados' : 'Modo teste · ' + quantosTelefones(atualV4.sdrContatos) + ' telefone(s) autorizado(s)' }}</small>
        <small class="resumo__link" *ngIf="!atualV4">{{ numerosV4.length ? 'Ativar um número pareado' : 'Nenhum número pareado' }}</small>
      </span>
      <span class="pilula" [ngClass]="atualV4 ? 'pilula--ok' : 'pilula--neutra'">{{ atualV4 ? 'Ativo' : 'Não definido' }}</span>
    </button>

    <button type="button" class="resumo__cartao" (click)="rolePara('canal-cloud')">
      <span class="resumo__icone" [class.ligado]="atual" aria-hidden="true"><i class="fas fa-cloud"></i></span>
      <span class="resumo__corpo">
        <span class="resumo__rotulo">Número oficial · Cloud API</span>
        <strong class="num">{{ carregando && !numeros.length ? 'Carregando…' : (atual ? formateTelefone(atual.telefone) : 'Nenhum número') }}</strong>
        <small *ngIf="atual">{{ atual.sdrContatos === '*' || !atual.sdrContatos ? 'Todo mundo conversa' : 'Modo teste · ' + quantosTelefones(atual.sdrContatos) + ' telefone(s) autorizado(s)' }}</small>
        <small *ngIf="!atual && fallbackAmbiente">Servidor usando a variável de ambiente</small>
        <small class="resumo__link" *ngIf="!atual && !fallbackAmbiente && !carregando">Escolher um número Cloud</small>
      </span>
      <span class="pilula" [ngClass]="atual ? 'pilula--ok' : (fallbackAmbiente ? 'pilula--atencao' : 'pilula--neutra')">
        {{ atual ? 'Ativo' : (fallbackAmbiente ? 'Ambiente' : 'Não definido') }}
      </span>
    </button>
  </nav>

  <!-- ===== WhatsApp pessoal pela extensão V4 ===== -->
  <section class="cartao canal" id="canal-v4" aria-labelledby="titulo-v4">
    <header class="canal__cabeca">
      <div>
        <h2 id="titulo-v4">WhatsApp pessoal pela extensão V4
          <span class="pilula" [ngClass]="escolhidoV4?.miaGestor ? 'pilula--ok' : 'pilula--neutra'">{{ escolhidoV4?.miaGestor ? 'Ativo' : 'Não definido' }}</span>
        </h2>
        <p>Atende os leads do site registrados depois da ativação. Só responde com o computador ligado e o Chrome aberto.</p>
        <p class="canal__meta" *ngIf="escolhidoV4">
          <strong class="num">{{ formateTelefone(escolhidoV4.telefone) }}</strong>
          <span *ngIf="escolhidoV4.empresa?.nome">{{ escolhidoV4.empresa?.nome }}</span>
          <span *ngIf="escolhidoV4.miaGestor && escolhidoV4.ativadoEm">ativado em {{ escolhidoV4.ativadoEm | date:"dd/MM/yyyy 'às' HH:mm" }}</span>
        </p>
      </div>
    </header>

    <div class="canal__corpo">
      <p class="faixa faixa--erro" role="alert" *ngIf="erroV4"><i class="fas fa-exclamation-circle" aria-hidden="true"></i>{{ erroV4 }}</p>
      <p class="faixa faixa--ok" role="status" *ngIf="avisoV4"><i class="fas fa-check-circle" aria-hidden="true"></i>{{ avisoV4 }}</p>
      <p class="vazio" *ngIf="!numerosV4.length && !erroV4">Nenhum número pareado na extensão V4.</p>

      <div class="seletor" *ngIf="numerosV4.length > 1" role="radiogroup" aria-label="Números pareados">
        <button type="button" *ngFor="let n of numerosV4" (click)="escolhaV4(n)" [disabled]="salvandoV4"
                [class.selecionado]="n.id === escolhidoV4?.id" role="radio" [attr.aria-checked]="n.id === escolhidoV4?.id">
          <span class="num">{{ formateTelefone(n.telefone) }}</span>
          <span class="seletor__ponto" *ngIf="n.miaGestor" title="Mia Gestor ativa neste número" aria-label="ativo"></span>
        </button>
      </div>

      <fieldset class="bloco" *ngIf="escolhidoV4">
        <legend>Quem pode conversar com a Mia Gestor</legend>
        <div class="opcao" [class.marcada]="quemConversaV4 === 'todos'">
          <label class="opcao__rotulo">
            <input type="radio" name="quemV4" value="todos" [(ngModel)]="quemConversaV4" [disabled]="salvandoV4">
            <span><strong>Todos os leads autorizados</strong><small>Quem veio do site e foi registrado depois da ativação.</small></span>
          </label>
        </div>
        <div class="opcao" [class.marcada]="quemConversaV4 === 'lista'">
          <label class="opcao__rotulo">
            <input type="radio" name="quemV4" value="lista" [(ngModel)]="quemConversaV4" [disabled]="salvandoV4">
            <span><strong>Só estes telefones <span class="pilula pilula--acento">Modo teste</span></strong><small>Use para testar antes de liberar para todos os leads.</small></span>
          </label>
          <div class="telefones" *ngIf="quemConversaV4 === 'lista'">
            <div class="telefones__cabeca"><span>Telefones autorizados</span><small>{{ listaV4.length }} telefone(s)</small></div>
            <ul class="chips" *ngIf="listaV4.length">
              <li *ngFor="let t of listaV4" class="chip">
                <span class="num">{{ formateTelefone(t) }}</span>
                <button type="button" (click)="remova('v4', t)" [disabled]="salvandoV4" [attr.aria-label]="'Remover ' + formateTelefone(t)"><i class="fas fa-times" aria-hidden="true"></i></button>
              </li>
            </ul>
            <div class="telefones__novo">
              <input type="tel" [(ngModel)]="novoTelefoneV4" (keydown.enter)="$event.preventDefault(); adicione('v4')" [disabled]="salvandoV4"
                     placeholder="(62) 99999-9999" aria-label="Novo telefone autorizado">
              <button type="button" (click)="adicione('v4')" [disabled]="salvandoV4 || !novoTelefoneV4.trim()">Adicionar</button>
            </div>
            <small>Brasil (+55) por padrão. Cole vários separados por vírgula.</small>
          </div>
        </div>
      </fieldset>

      <fieldset class="bloco" *ngIf="escolhidoV4">
        <legend>Follow-up automático</legend>
        <div class="opcao" [class.marcada]="followupV4">
          <label class="opcao__rotulo">
            <input type="checkbox" name="followupV4" [(ngModel)]="followupV4" [disabled]="salvandoV4">
            <span><strong>Retomar leads que param de responder</strong>
              <small>Toques em 1, 3 e 7 dias depois da última mensagem do lead, só na conversa comercial, sem teste criado e sem pausa por atendente. Qualquer resposta do lead cancela os toques. Dá para desligar por lead no cartão do contato.</small></span>
          </label>
        </div>
      </fieldset>
    </div>

    <footer class="rodape" *ngIf="escolhidoV4">
      <button type="button" class="perigo" *ngIf="escolhidoV4.miaGestor" (click)="salveV4(false)" [disabled]="salvandoV4">Desconectar este número</button>
      <span class="rodape__estado" *ngIf="mudouV4">Alterações não salvas</span>
      <button type="button" *ngIf="mudouV4" (click)="descarteV4()" [disabled]="salvandoV4">Descartar</button>
      <button type="button" class="primario" (click)="salveV4(true)" [disabled]="salvandoV4 || (escolhidoV4.miaGestor && !mudouV4)">
        {{ salvandoV4 ? 'Salvando…' : (escolhidoV4.miaGestor ? 'Salvar' : 'Ativar a Mia Gestor neste número') }}
      </button>
    </footer>
  </section>

  <!-- ===== Número oficial (Cloud API) ===== -->
  <section class="cartao canal" id="canal-cloud" aria-labelledby="titulo-cloud">
    <header class="canal__cabeca">
      <div>
        <h2 id="titulo-cloud">Número oficial (Cloud API)
          <span class="pilula" [ngClass]="atual ? 'pilula--ok' : (fallbackAmbiente ? 'pilula--atencao' : 'pilula--neutra')">
            {{ atual ? 'Ativo' : (fallbackAmbiente ? 'Variável de ambiente' : 'Não definido') }}
          </span>
        </h2>
        <p>Atende 24h, sem depender do computador.</p>
        <p class="canal__meta" *ngIf="atual">
          <strong class="num">{{ formateTelefone(atual.telefone) }}</strong>
          <span>{{ atual.nome }}</span>
          <span *ngIf="atual.empresa?.nome">{{ atual.empresa?.nome }}</span>
        </p>
        <p class="canal__meta" *ngIf="!atual && fallbackAmbiente">
          <span>Nenhum número escolhido aqui. O servidor usa o phone_number_id <code>{{ fallbackAmbiente }}</code>.</span>
        </p>
      </div>
    </header>

    <div class="canal__corpo" *ngIf="erro || aviso">
      <p class="faixa faixa--erro" role="alert" *ngIf="erro"><i class="fas fa-exclamation-circle" aria-hidden="true"></i>{{ erro }}</p>
      <p class="faixa faixa--ok" role="status" *ngIf="aviso"><i class="fas fa-check-circle" aria-hidden="true"></i>{{ aviso }}</p>
    </div>

    <ng-container *ngIf="escolhido">
      <div class="canal__corpo">
        <div class="escolha" *ngIf="!escolhido.miaGestor">
          <span>Novo número da Mia Gestor: <strong class="num">{{ formateTelefone(escolhido.telefone) }}</strong> · {{ escolhido.empresa?.nome || escolhido.nome }}</span>
          <button type="button" class="fantasma" (click)="descarte()" [disabled]="salvando">Cancelar</button>
        </div>

        <fieldset class="bloco">
          <legend>Quem pode conversar com a Mia Gestor</legend>
          <div class="opcao" [class.marcada]="quemConversa === 'todos'">
            <label class="opcao__rotulo">
              <input type="radio" name="quem" value="todos" [(ngModel)]="quemConversa" [disabled]="salvando">
              <span><strong>Todo mundo</strong><small>Qualquer contato que mandar mensagem entra no atendimento comercial.</small></span>
            </label>
          </div>
          <div class="opcao" [class.marcada]="quemConversa === 'lista'">
            <label class="opcao__rotulo">
              <input type="radio" name="quem" value="lista" [(ngModel)]="quemConversa" [disabled]="salvando">
              <span><strong>Só estes telefones <span class="pilula pilula--acento">Modo teste</span></strong><small>Use para testar antes de abrir para todo mundo.</small></span>
            </label>
            <div class="telefones" *ngIf="quemConversa === 'lista'">
              <div class="telefones__cabeca"><span>Telefones autorizados</span><small>{{ lista.length }} telefone(s)</small></div>
              <ul class="chips" *ngIf="lista.length">
                <li *ngFor="let t of lista" class="chip">
                  <span class="num">{{ formateTelefone(t) }}</span>
                  <button type="button" (click)="remova('cloud', t)" [disabled]="salvando" [attr.aria-label]="'Remover ' + formateTelefone(t)"><i class="fas fa-times" aria-hidden="true"></i></button>
                </li>
              </ul>
              <div class="telefones__novo">
                <input type="tel" [(ngModel)]="novoTelefone" (keydown.enter)="$event.preventDefault(); adicione('cloud')" [disabled]="salvando"
                       placeholder="(62) 99999-9999" aria-label="Novo telefone autorizado">
                <button type="button" (click)="adicione('cloud')" [disabled]="salvando || !novoTelefone.trim()">Adicionar</button>
              </div>
              <small>Brasil (+55) por padrão. Cole vários separados por vírgula. Inclua também a variante sem o nono dígito.</small>
            </div>
          </div>
          <p class="nota"><i class="fas fa-info-circle" aria-hidden="true"></i>A implantação por convite continua funcionando para qualquer contato com link válido, independente desta escolha.</p>
        </fieldset>

        <fieldset class="bloco">
          <legend>Número de exemplo da Mia</legend>
          <div class="exemplo">
            <div>
              <p class="exemplo__estado" [class.ligado]="escolhido.exemploMia">
                <span class="ponto" aria-hidden="true"></span>
                {{ escolhido.exemploMia ? 'Este número é um número de exemplo' : 'Não é número de exemplo' }}
              </p>
              <p class="orientacao">Ligado, a tela de cada contato da empresa <strong>{{ escolhido.empresa?.nome }}</strong> ganha a seção
                "Demonstração da MIA": o contato é atendido como se fosse outra empresa, com o cardápio dela, sem criar pedido real.</p>
            </div>
            <button type="button" (click)="alterneExemploMia()" [disabled]="salvando || salvandoExemplo">
              {{ salvandoExemplo ? 'Salvando…' : (escolhido.exemploMia ? 'Deixar de ser exemplo' : 'Tornar número de exemplo') }}
            </button>
          </div>
        </fieldset>
      </div>

      <footer class="rodape">
        <button type="button" class="perigo" *ngIf="escolhido.miaGestor" (click)="desligue()" [disabled]="salvando">Deixar de ser a Mia Gestor</button>
        <span class="rodape__estado" *ngIf="mudou && atual">Alterações não salvas</span>
        <button type="button" *ngIf="mudou && atual" (click)="descarte()" [disabled]="salvando">Descartar</button>
        <button type="button" class="primario" (click)="salve()" [disabled]="salvando || !mudou">
          {{ salvando ? 'Salvando…' : (escolhido.miaGestor ? 'Salvar' : 'Tornar este o número da Mia Gestor') }}
        </button>
      </footer>
    </ng-container>

    <div class="tabela">
      <div class="tabela__barra">
        <h3>{{ atual ? 'Trocar de número' : 'Números Cloud cadastrados' }} <span class="contagem" *ngIf="numeros.length">{{ numeros.length }}</span></h3>
        <div class="busca">
          <i class="fas fa-search" aria-hidden="true"></i>
          <input [(ngModel)]="filtro" placeholder="Nome, telefone, id ou empresa" aria-label="Buscar número Cloud">
        </div>
      </div>
      <p class="vazio" *ngIf="!numeros.length && !carregando">Nenhum número Cloud cadastrado.</p>
      <p class="vazio" *ngIf="numeros.length && !filtrados.length">Nenhum número para esta busca.</p>
      <table *ngIf="filtrados.length">
        <thead><tr><th>Empresa</th><th>Número</th><th class="col-id">ID do número</th><th><span class="sr-only">Ação</span></th></tr></thead>
        <tbody>
          <tr *ngFor="let n of filtrados" [class.selecionado]="n.id === escolhidoId">
            <td>
              <strong>{{ n.empresa?.nome || n.nome }}</strong>
              <small *ngIf="n.empresa?.nome && n.nome">{{ n.nome }}</small>
              <span class="selos" *ngIf="n.miaGestor || n.exemploMia">
                <span class="selo selo--mia" *ngIf="n.miaGestor">Mia Gestor</span>
                <span class="selo selo--exemplo" *ngIf="n.exemploMia">Exemplo</span>
              </span>
            </td>
            <td class="num">{{ formateTelefone(n.telefone) }}</td>
            <td class="col-id mono">{{ n.whatsappId }}</td>
            <td class="col-acao">
              <span class="em-uso" *ngIf="n.miaGestor">Em uso</span>
              <button type="button" *ngIf="!n.miaGestor" (click)="escolha(n)" [disabled]="salvando || n.id === escolhidoId">
                {{ n.id === escolhidoId ? 'Escolhido' : 'Usar como Mia Gestor' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</main>
